import React from "react";
import "../stylesheets/DevLogList.css";
import { logs } from "./DevLog";

class DevLogList extends React.Component {
  componentDidMount() {
    const content = document.getElementsByClassName("sneak-content");

    if (content[0].scrollHeight < 160) {
      const button = document.getElementsByClassName("sneak-link");

      button[0].innerText = "Visit Page";
    }
  }

  logSneak = ({ content, id }) => {
    const {children} = content.props;

    return (
      <div className="sneak-container">
        <h1 className="sneak-title">
          Discovery Log #{id}: {children[0].props.children}
        </h1>
        <h4 className="sneak-date">
          {children[1].props.children}
        </h4>
        <div className="sneak-content">
          {children[2].props.children}
        </div>
        <a className="sneak-link" href={`/devlog/${id}`}>
          Continue Reading
        </a>
      </div>
    );
  };

  renderList() {
    let rows = [];

    for (let i = logs.length - 1; i > 0; i--) {
      if (i === logs.length - 4 && this.props.path === "/") {
        break;
      }

      rows.push(<this.logSneak content={logs[i]} id={`${i}`} key={i} />);
    }

    return <div>{rows}</div>;
  }

  renderShowMore() {
    if (this.props.path === "/" && logs.length > 3) {
      return (
        <a href="/devlogs" className="see-all">
          See All
        </a>
      );
    }
  }

  render() {
    return (
      <div className="devloglist-container" id="devlogs">
        <h1 className="devloglist-title">Developer Logs</h1>
        <div className="devloglist">
          {this.renderList()} {this.renderShowMore()}
        </div>
      </div>
    );
  }
}

export default DevLogList;
